"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_ROOT = void 0;
var API_ROOT = process.env.NODE_ENV === 'development' ? '/api/v2' : 'https://api.ulabox.com/api/v2';
exports.API_ROOT = API_ROOT;